window.serendis.resultsChart = function(
		$chart,
		groups,
		polar = true,
		includeRespondentLowest = true,
		includeSubjectAverages = false,
		selfAssessment = false,
		includeIndividualQuestionsAverages = true,
		includeTargetLine = true,
		includeDimensionsAverage = false
	) {

	var dangerColour = '#BAE4EE';

	function hexToRgbA(hex, opacity){
		var c;
		if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
			c= hex.substring(1).split('');
			if(c.length== 3){
				c= [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c= '0x'+c.join('');
			return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + opacity + ')';
		}
		throw new Error('Bad Hex');
	}

	// Parse results and dimensions
	var dimensionNames = {},
		dimensions = [],
		mainResults = [],
		dimensionsAverageScores = [],
		questionNumbers = [],
		respondentLowestScores = [],
		subjectResults = [],
		x = 0,
		questionX = 0,
		totalDimensions = 0,
		totalQuestions = 0,
		tickPositions = [],
		plotLinesX = [];

	// Calculate totals
	window._.each(groups, function(group) {
		window._.each(group.dimensions, function(dimension) {
			totalDimensions ++;
			window._.each(dimension.questions, function(question) {
				totalQuestions ++;
			});
		});
	});

	// Loop groups
	window._.each(groups, function(group) {
		
		// Loop dimensions
		window._.each(group.dimensions, function(dimension) {

			var dimensionsAverageScore = 0;
			var questionsWithResponsesCount = 0;
			var questionScore = 0;
			window._.each(dimension.questions, function(question, questionIndex) {
				questionScore = selfAssessment ? question.normalisedScoreSubject.score : question.normalisedScoreRespondents.score;
				dimensionsAverageScore = dimensionsAverageScore + questionScore;
				questionsWithResponsesCount = questionsWithResponsesCount + (questionScore > 0 ? 1 : 0);
			});
			dimensionsAverageScore = questionsWithResponsesCount ?  dimensionsAverageScore / questionsWithResponsesCount : 0;

			// Loop questions
			window._.each(dimension.questions, function(question, questionIndex) {

				// Main results
				var mainResultsScore = selfAssessment ? question.normalisedScoreSubject.score : question.normalisedScoreRespondents.score;
				mainResults.push({
					y:mainResultsScore != null ? mainResultsScore : window.serendis.normalisedMax,
					color:mainResultsScore != null ? hexToRgbA(group.color, 1) : '#cccccc',
					name:mainResultsScore != null ? null : 'No data'
				});

				// Lowest scores
				respondentLowestScores.push({
					y: question.normalisedScoreRespondents.lowestScore,
					color:dangerColour,
					symbol:'circle'
				});

				// Dimensions average scores
				dimensionsAverageScores.push({
					y: Math.round(dimensionsAverageScore),
					color: hexToRgbA(group.color, 1),
					symbol: 'circle',
					parentNameLabel: 'Dimension',
					parentNameValue: dimension.name,
					borderColor:hexToRgbA(group.color, 1),
					borderWidth: 2,
				});

				// Subject average
				subjectResults.push({
					y:question.normalisedScoreSubject.score
				});

				// Question numbers
				questionNumbers.push(question.number);

				// plotlinesX
				plotLinesX.push({
					color:questionIndex === 0 && polar ? '#999999' : 'transparent',
					width: 1,
					value: questionX - 0.5,
					zIndex:20
				});

				// Dimension name
				if (questionIndex === 0) {
					var dimensionNameX = questionX - 0.5 + dimension.questions.length / 2;
					dimensionNames[dimensionNameX] = dimension.name.replace(' ', '<br>');
					tickPositions.push(dimensionNameX);
					dimensions.push({x: questionX, y: 0});
				}

				// Counter
				questionX ++;

			});
			
			x ++;

		});

	});

	// PlotlinesY
	var ticks = window.serendis.answerOptions.length,
		plotLinesY = [];
	for (var i = 0; i < window.serendis.normalisedMax / ticks; i ++) {
		plotLinesY.push({
			color:'rgba(0,0,0,0.1)',
			width: 1,
			value: (i + 1) * ticks,
			zIndex:20
		});
	}

	if (includeTargetLine) {
		plotLinesY.push({
			color: '#0f73a7',
			width: 1,
			value: 15,
			dashStyle:'LongDash',
			zIndex:30
		})
	}

	// Series
	var series = [];

	// Main results
	if (includeIndividualQuestionsAverages) {
		series.push({
			type: 'column',
			name: 'Average',
			data: mainResults,
			grouping:false,
			xAxis:0,
			dataLabels: {
				crop:false
			}
		});
	}

	// Respondent lowest
	if (includeRespondentLowest) {
		series.push({
			type: 'line',
			name: 'Lowest',
			data: respondentLowestScores,
			grouping:false,
			xAxis:0,
			lineWidth:polar ? 1 : 0,
			zIndex:8,
			color:dangerColour,
			marker: {
				symbol: 'circle',
				radius:polar ? 3 : 6
			}
		});
	}

	if (includeDimensionsAverage) {
		series.push({
			type: 'column',
			name: 'Average',
			parentName: 'Dimensions',
			data: dimensionsAverageScores,
			grouping: false,
			xAxis:0,
			lineWidth:3,
			zIndex:6,
			color:'#FFFF00',
			marker: {
				enabled: false
			},
			states: {
				hover: {
					enabled: false,
				}
			},
		});
	}

	// Dimensions
	if (totalDimensions > 1) {
		series.push({
			type: 'column',
			name: 'Column',
			data: dimensions,
			grouping:false,
			xAxis:1,
			dataLabels: {
				crop:false
			}
		});
	}

	// Subject averages
	if (includeSubjectAverages) {
		series.push({
			type: 'line',
			name: 'Self',
			data: subjectResults,
			color:'#000000',
			grouping:false,
			xAxis:0,
			lineWidth:polar ? 1 : 0,
			zIndex:6,
			marker: {
				radius:polar ? 3 : 6
			}
		});
	}

	// Create chart
	Highcharts.chart($chart.attr('id'), {

		chart: {
			polar: polar,
			type:'column',
			renderTo:$chart.attr('id'),
			backgroundColor:'rgba(255, 255, 255, 0.0)',
			margin: polar ? ($chart.hasClass('results-chart-small') ? [50,120,50,120] : [95,95,95,95]) : [30,40,40,90]
		},

		legend:false,
		credits:false,
		title:false,
		tooltip: {
			enabled:true,
			animation:true,
			formatter: function() {
				return '<small>' + (this.point.parentNameLabel ? this.point.parentNameLabel : 'Question') + ' ' + (this.point.parentNameValue ? this.point.parentNameValue : this.x) +
				'</small><br><b>' + this.series.name + ': ' + (this.point.name ? this.point.name : (this.y + '/' + window.serendis.normalisedMax)) + '</b>';
			}
		},

		pane:{
			size: '100%',
		},

		xAxis: [

			{
				categories: includeDimensionsAverage ? dimensionNames : questionNumbers,
				tickPositions: includeDimensionsAverage ? tickPositions : null,
				max:polar ? totalQuestions : null,
				labels: {
					distance:10,
					style: {
						color: includeDimensionsAverage ? '#ffffff' : '#444444',
						fontSize:'8px'
					},
					zIndex:7
				},
				lineWidth:0,
				plotLines: plotLinesX,
				gridZIndex:2,
				gridLineColor: includeDimensionsAverage ? 'transparent' : '#eaeaea',
			},

			{
				categories: dimensionNames,
				tickPositions:tickPositions,
				// tickmarkPlacement:'on',
				max:polar ? totalQuestions : null,
				labels: {
					distance:35,
					style: {
						color:'#004467'
					},
					zIndex:7
				},
				lineWidth:0,
				gridLineColor:'transparent',
				showLastLabel: true,
				// gridZIndex:2,
			}

		],
		yAxis: {
			min: 0,
			max: window.serendis.normalisedMax,
			showLastLabel: true,
			labels: {
	            formatter: function() {
	                return window.serendis.answerOptions[this.value / window.serendis.answerOptions.length];
	            },
	            align:'right',
	            y:-18,
	            overflow:true,
	            style: {
					color:'#bbbbbb'
	            }
	        },
			tickInterval:ticks,
			gridLineColor:'rgba(255, 255, 255, 0.0)',
			plotLines: plotLinesY,
			title: {
				enabled:false
			}
		},
		plotOptions: {
			series: {
				pointStart: 0,
				states: {
					hover: {
						enabled: true
					}
				}
			},
			column: {
				pointPadding: 0,
				groupPadding: 0,
			},
			line: {
				marker: {
					radius:3
				}
			}
		},
		series: series
	});

};